const logos = [
  '/logos/1 (1).webp',
  '/logos/12_.webp',
    '/logos/1 (6).webp',
  '/logos/11_.webp',
  '/logos/1 (102).svg',
  '/logos/1 (104).svg',
  '/logos/1 (3).webp',
  '/logos/1 (4).webp',
  '/logos/1 (5).webp',
  '/logos/1 (8).webp',
  '/logos/1 (9).webp',
  '/logos/1 (12).webp',
  '/logos/1 (13).webp',
  '/logos/1 (14).webp',
  '/logos/1 (15).webp',
  '/logos/1 (19).webp',
  '/logos/1 (20).webp',
  '/logos/1 (21).webp',
  '/logos/1 (23).webp',
  '/logos/1 (24).webp',
  '/logos/1 (25).webp',
  '/logos/1 (7).svg',
  '/logos/1 (8).svg',
  '/logos/1 (9).svg',
  '/logos/1 (10).svg',
  '/logos/1 (11).svg',
  '/logos/1 (12).svg',
  '/logos/1 (13).svg',
  '/logos/1 (14).svg',
  '/logos/1 (15).svg',
  '/logos/1 (16).svg',
  '/logos/1 (17).svg',
  '/logos/1 (18).svg',
  '/logos/1 (19).svg',
  '/logos/1 (26).svg',
  '/logos/1 (27).svg',
  '/logos/1 (28).svg',
  '/logos/1 (31).svg',
  '/logos/1 (32).svg',
  '/logos/1 (33).svg',
  '/logos/1 (34).svg',
  '/logos/1 (35).svg',
  '/logos/1 (36).svg',
  '/logos/1 (37).svg',
  '/logos/1 (38).svg',
  '/logos/1 (39).svg',
  '/logos/1 (40).svg',
  '/logos/1 (41).svg',
  '/logos/1 (42).svg',
  '/logos/1 (43).svg',
  '/logos/1 (44).svg',
  '/logos/1 (45).svg',
  '/logos/1 (46).svg',
  '/logos/1 (47).svg',
  '/logos/1 (48).svg',
  '/logos/1 (85).svg',
  '/logos/1 (86).svg',
  '/logos/1 (87).svg',
  '/logos/1 (88).svg',
  '/logos/1 (90).svg',
  '/logos/1 (91).svg',
  '/logos/1 (92).svg',
  '/logos/1 (94).svg',
  '/logos/1 (95).svg',
  '/logos/1 (96).svg',
  '/logos/1 (97).svg',

];

export default logos;
